import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

// Set default timezone to local
const localTimezone = dayjs.tz.guess(); // Automatically detects user's local timezone
dayjs.tz.setDefault(localTimezone);

// Default date format
const DEFAULT_FORMAT = "MMM D, YYYY";

// Helper to format with default
const formatDate = (date: string | Date, format = DEFAULT_FORMAT) => {
  return dayjs(date).format(format);
};
console.log({ localTimezone });

export { formatDate, DEFAULT_FORMAT, localTimezone };
